import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {},

  line: {
    width: 89,
    borderTopWidth: 2,
    borderColor: '#ffffff',
    marginTop: 20,
    marginBottom: 20,
  },

  contentWrapper: {
    paddingHorizontal: 40,
    marginTop: 20,
    width: '100%',
  },

  columnsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: 30,
  },

  leftColumn: {
    width: 245,
  },

  rightColumn: {
    width: 219,
  },

  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 900,
  },

  titleUnderline: {
    width: 89,
    borderTopWidth: 2,
    marginTop: 15,
    marginBottom: 15,
  },

  description: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 11,
    textAlign: 'left',
  },

  itemTitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 900,
    fontSize: 9,
    textAlign: 'left',
    marginBottom: 5,
  },
  itemText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 9,
    textAlign: 'left',
  },

  image: {
    width: 219,
    height: 149,
    objectFit: 'cover',
    borderRadius: 4,
  },
});
